export const EVENT_TYPE_OPTIONS = [
    { value: "local", label: "Local" },
    { value: "safar", label: "Safar" },
    { value: "intl", label: "International Miqaat" },
];

export const EVENT_MODE_OPTIONS = [
    { value: "standard", label: "Standard Event" },
    { value: "division_registration", label: "Division Registration Event" },
];

export const EVENT_MODE_LABEL_MAP = {
    standard: "Standard",
    division_registration: "Division Registration",
};

export const ATTENDANCE_STATUS_LABELS = {
    0: "Not Responded",
    1: "Present",
    2: "Present (Late)",
    3: "Absent",
    4: "Out of Station",
    5: "INT Khidmat",
    6: "Leave",
};

export const EVENT_TYPE_FILTER_OPTIONS = [
    { value: "all", label: "All" },
    ...EVENT_TYPE_OPTIONS,
];

export const EVENT_TYPE_LABEL_MAP = EVENT_TYPE_OPTIONS.reduce((acc, item) => {
    acc[item.value] = item.label;
    return acc;
}, {});
